import * as actionTypes from "../constants/actionTypes";
import PageTitle from "../components/layout/pageTitle";

export function updatePageTitle(pageTitle) {
    PageTitle(pageTitle);
    return {type: actionTypes.UPDATE_PAGETITLE, pageTitle};
}
